module.exports = __webpack_public_path__ + "static/nz-732adfdfadf4aee3da188f6ecf1c9560.svg";